import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'apps/piqet-angular/src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MyOrganizationService {
  apiUrl = environment.url;

  constructor(private http: HttpClient) {}

  getTeamsList(teamsPayload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/MyOrganizationTeam/GetMyOrganizationTeamList`,
      teamsPayload
    );
  }
  //manage teams new API
  getAllTeamsList() {
    return this.http.get<any>(`${this.apiUrl}/MyOrganizationTeam/GetAllMyOrganizationTeamList`);
  }
  getTeamsListForAdmin(teamsPayload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/AdminMyOrganizationTeam/GetMyOrganizationTeamListForAdmin`,
      teamsPayload
    );
  }
  //manage teams new API
  getAllTeamsListForAdmin() {
    return this.http.get<any>(
      `${this.apiUrl}/AdminMyOrganizationTeam/GetAllMyOrganizationTeamListForAdmin`
    );
  }
  getTeamsIndex(organizationId: any, userId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/CustomStorage/CustomIndex?userId=${userId}&organizationId=${organizationId}`
    );
  }

  deleteManageData(id: number, managetype: any) {
    if (id) {
      return this.http.delete<any>(`${this.apiUrl}${managetype}=${id}`);
    }
    return this.http.delete<any>(`${this.apiUrl}${managetype}`);
  }

  getUsersList(usersListPayload: any) {
    return this.http.post<any>(`${this.apiUrl}/MyOrganizationUsers/GetUserList`, usersListPayload);
  }

  getAllUsersList() {
    return this.http.get<any>(`${this.apiUrl}/MyOrganizationUsers/GetAllUserList`);
  }

  getOrganizationUserList() {
    return this.http.get<any>(`${this.apiUrl}/MyOrganizationUsers/GetOrganizationUserList`);
  }

  getUsersListForAdmin(usersListPayload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/AdminMyOrganizationUser/GetUserListforAdmin`,
      usersListPayload
    );
  }

  getAllUsersListForAdmin() {
    return this.http.get<any>(`${this.apiUrl}/AdminMyOrganizationUser/GetAllUserListforAdmin`);
  }

  getProjectWorkflowList(projectWorkflowPayload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/MyOrganizationManageProjectWorkflow/GetProjectWorkFlowList`,
      projectWorkflowPayload
    );
  }

  getManageScenarioWorkflowList() {
    return this.http.get<any>(
      `${this.apiUrl}/MyOrganizationManageScenarioWorkflow/GetAllManageScenarioWorkflowList`
    );
  }

  getAllProjectWorkflowList() {
    return this.http.get<any>(
      `${this.apiUrl}/MyOrganizationManageProjectWorkflow/GetAllProjectWorkFlowList`
    );
  }

  getProductGroupsList(productGroupsPayload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/MyOrganizationProductGroup/GetMyOrganizationProductGroupList`,
      productGroupsPayload
    );
  }
  getAllMyOrganizationProductGroupList() {
    return this.http.get<any>(
      `${this.apiUrl}/MyOrganizationProductGroup/GetAllMyOrganizationProductGroupList`
    );
  }
  resendConfirmationMail(email: any, url: any) {
    return this.http.get<any>(
      `${this.apiUrl}/User/ResendConfirmationMail?email=${email}&url=${url}`
    );
  }

  manualActivateUser(userId: any, activationCode: any) {
    return this.http.get<any>(
      `${this.apiUrl}/User/ManualActivateUser?userId=${userId}&activationCode=${activationCode}`
    );
  }
  manualReviewerUser(userId: any) {
    return this.http.get<any>(`${this.apiUrl}/User/ReviewerUserverification?userId=${userId}`);
  }
  getSuppliersList(supplierListPayload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/MyOrganizationPreferences/GetSupplierList`,
      supplierListPayload
    );
  }

  getSuppliersListAsync(supplierListPayload: any) {
    return this.http
      .post<any>(`${this.apiUrl}/MyOrganizationPreferences/GetSupplierList`, supplierListPayload)
      .toPromise();
  }
  getAllSupplierList() {
    return this.http.get<any>(`${this.apiUrl}/MyOrganizationPreferences/GetAllSupplierList `);
  }
  getCustomCategoryList() {
    return this.http.get<any>(`${this.apiUrl}/MyOrganizationPreferences/GetCustomCategory`);
  }

  getLitterImpactList() {
    return this.http.get<any>(
      `${this.apiUrl}/MyOrganizationPreferences/GetOrganizationLitterImpactList`
    );
  }

  getYearEndsOnData() {
    return this.http.get<any>(
      `${this.apiUrl}/MyOrganizationPreferences/GetOrganizationEndYearList`
    );
  }

  getCustomSpeedosData() {
    return this.http.get<any>(
      `${this.apiUrl}/MyOrganizationPreferences/GetOrganizationSpeedosList`
    );
  }

  getPackagingMetricsData() {
    return this.http.get<any>(`${this.apiUrl}/MyOrganizationPreferences/GetPackagingMetrics`);
  }

  getProjectSavingLogsList(projectSavingLogsPayload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/ProjectSavingLog/GetProjectSavingLogList`,
      projectSavingLogsPayload
    );
  }

  getAllProjectSavingLogList() {
    return this.http.get<any>(`${this.apiUrl}/ProjectSavingLog/GetAllProjectSavingLogList`);
  }

  getManageSupportList() {
    return this.http.get<any>(`${this.apiUrl}/ManageSupport/GetManageSupportList`);
  }

  saveSupportUser(id: any) {
    return this.http.post<any>(`${this.apiUrl}/ManageSupport/SaveSupportUser?userId=${id}`, {});
  }

  exportLogs() {
    return this.http.get<any>(`${this.apiUrl}/ExportLogs/ExportLogReport`);
  }

  getSSOConfiguration() {
    return this.http
      .get<any>(`${this.apiUrl}/MyOrganizationSSOConfiguration/GetSSOConfiguration`)
      .toPromise();
  }

  saveSSOConfiguration(ssoConfigData: any) {
    return this.http.post<any>(
      `${this.apiUrl}/MyOrganizationSSOConfiguration/SaveSSOConfiguration`,
      ssoConfigData
    );
  }
  enableMFA(IsMFAEnabled: boolean) {
    return this.http.post(
      `${this.apiUrl}/MyOrganizationSSOConfiguration/EnableDisableMFA?IsMFAEnabled=${IsMFAEnabled}`,
      {}
    );
  }
  getSSOGroupList(ssoGroupPayload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/MyOrganizationSSOConfiguration/GetSSOGroupList`,
      ssoGroupPayload
    );
  }
  getAllSSOGroupList() {
    return this.http.get<any>(`${this.apiUrl}/MyOrganizationSSOConfiguration/GetAllSSOGroupList`);
  }
  getOrgSSOConfiguration(id: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/MyOrganizationSSOConfiguration/GetOrganizationSSOConfigurationForAddEdit?id=${id}`
      )
      .toPromise();
  }

  saveOrgSSOConfiguration(groupData: any) {
    return this.http.post<any>(
      `${this.apiUrl}/MyOrganizationSSOConfiguration/SaveOrganizationSSOConfiguration`,
      groupData
    );
  }

  addManageUser(manageUserData: any) {
    return this.http.post<any>(`${this.apiUrl}/MyOrganizationUsers/SaveNewUser`, manageUserData);
  }

  getManageUserDataForAdd(manageUserId: any) {
    return this.http
      .get<any>(`${this.apiUrl}/MyOrganizationUsers/GetAddUserFormDetail?usertype=${manageUserId}`)
      .toPromise();
  }

  getManageUserDataForEdit(manageUserId: any, organizationId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/MyOrganizationUsers/GetEditUserFormDetail?userId=${manageUserId}&organizationId=${organizationId}`
      )
      .toPromise();
  }

  SaveMyOrganizationEditUserForEdit(manageUserData: any) {
    return this.http.post<any>(
      `${this.apiUrl}/MyOrganizationUsers/SaveMyOrganizationEditUser`,
      manageUserData
    );
  }

  getMyTeamsAddEditData(id: any) {
    return this.http
      .get<any>(`${this.apiUrl}/MyOrganizationTeam/GetMyOrganizationTeamData?id=${id}`)
      .toPromise();
  }

  getMyTeamsAddEditDataForAdmin(id: any) {
    return this.http
      .get<any>(`${this.apiUrl}/AdminMyOrganizationTeam/GetMyOrganizationTeamDataForAdmin?id=${id}`)
      .toPromise();
  }

  addEditMyTeamsData(data: any) {
    return this.http.post<any>(
      `${this.apiUrl}/MyOrganizationTeam/AddUpdateMyOrganizationTeam`,
      data
    );
  }

  addEditMyTeamsDataForAdmin(data: any) {
    return this.http.post<any>(
      `${this.apiUrl}/AdminMyOrganizationTeam/AddUpdateMyOrganizationTeamForAdmin`,
      data
    );
  }

  getManageProductGroupsData(id: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/MyOrganizationProductGroup/GetMyOrganizationProductGroupData?id=${id}`
      )
      .toPromise();
  }

  addEditManageProductGroupsData(data: any) {
    return this.http.post<any>(
      `${this.apiUrl}/MyOrganizationProductGroup/AddUpdateMyOrganizationProductGroup`,
      data
    );
  }

  getManageProjectWorkFlowData(id: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/MyOrganizationManageProjectWorkflow/GetProjectWorkFlowData?id=${id}`
      )
      .toPromise();
  }

  addEditManageProjectWorkFlowData(data: any) {
    return this.http.post<any>(
      `${this.apiUrl}/MyOrganizationManageProjectWorkflow/AddUpdateMyOrganizationProjectWorkFlow`,
      data
    );
  }

  getManageScenarioWorkFlowData(id: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/MyOrganizationManageScenarioWorkflow/GetScenarioWorkFlowData?id=${id}`
      )
      .toPromise();
  }

  addEditManageScenarioWorkFlowData(data: any) {
    return this.http.post<any>(
      `${this.apiUrl}/MyOrganizationManageScenarioWorkflow/AddUpdateMyOrganizationScenarioWorkFlow`,
      data
    );
  }

  getSupplierData(supplierId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/MyOrganizationPreferences/GetSupplierFormData?supplierId=${supplierId}`
    );
  }

  addEditSupplierData(data: any) {
    return this.http.post<any>(`${this.apiUrl}/MyOrganizationPreferences/AddUpdateSupplier`, data);
  }

  getOrgYearEndFormData() {
    return this.http.get<any>(
      `${this.apiUrl}/MyOrganizationPreferences/GetOrganizationEndYearFormData`
    );
  }

  editOrgYearEndData(data: any) {
    return this.http.post<any>(
      `${this.apiUrl}/MyOrganizationPreferences/CreateOrganizationEndYear`,
      data
    );
  }

  getCustomSpeedosFormData() {
    return this.http.post<any>(
      `${this.apiUrl}/MyOrganizationPreferences/GetOrganizationSpeedosFormData`,
      {}
    );
  }

  getCustomSpeedosAsync() {
    return this.http
      .post<any>(`${this.apiUrl}/MyOrganizationPreferences/GetOrganizationSpeedosFormData`, {})
      .toPromise();
  }

  editCustomSpeedosData(data: any) {
    return this.http.post<any>(
      `${this.apiUrl}/MyOrganizationPreferences/AddUpdateOrganizationSpeedos`,
      data
    );
  }

  getPackagingMetricsFormData() {
    return this.http.get<any>(
      `${this.apiUrl}/MyOrganizationPreferences/GetPackagingMetricsForEdit`
    );
  }

  getPackagingMetricsFormDataAsync() {
    return this.http
      .get<any>(`${this.apiUrl}/MyOrganizationPreferences/GetPackagingMetricsForEdit`)
      .toPromise();
  }

  editPackagingMetricsData(data: any) {
    return this.http.post<any>(
      `${this.apiUrl}/MyOrganizationPreferences/SaveOrganizationPackagingMetrics`,
      data
    );
  }

  getCustomCategoryFormData() {
    return this.http.get<any>(`${this.apiUrl}/MyOrganizationPreferences/GetCustomCategoryForEdit`);
  }

  getCustomCategoryFormDataAsync() {
    return this.http
      .get<any>(`${this.apiUrl}/MyOrganizationPreferences/GetCustomCategoryForEdit`)
      .toPromise();
  }

  editCustomCategoryData(data: any) {
    return this.http.post<any>(`${this.apiUrl}/MyOrganizationPreferences/SaveCustomCategory`, data);
  }

  getEditLitterImpactAsync() {
    return this.http.get<any>(
      `${this.apiUrl}/MyOrganizationPreferences/GetOrganizationLitterImpactFormData`
    );
  }

  editLitterImpactData(data: any) {
    return this.http.post<any>(
      `${this.apiUrl}/MyOrganizationPreferences/AddUpdateLitterImpact`,
      data
    );
  }

  getUserDetailsList(userId: any) {
    return this.http
      .get<any>(`${this.apiUrl}/MyOrganizationUsers/GetUserDetail?userId=${userId}`)
      .toPromise();
  }

  getAdminOrganizationDetailsList(userId: any) {
    return this.http
      .get<any>(`${this.apiUrl}/Organization/GetAddOrganizationDetail?organizationId=${userId}`)
      .toPromise();
  }

  getAdminOrganizationDetailsListSync(userId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/Organization/GetAddOrganizationDetail?organizationId=${userId}`
    );
  }

  getManageUserDetailsGridData(id: any) {
    return this.http
      .get<any>(`${this.apiUrl}/MyOrganizationUsers/GetAllOrganizationMembershipList?userId=${id}`)
      .toPromise();
  }

  getTeamMembershipGridData(id: any) {
    return this.http
      .get<any>(`${this.apiUrl}/MyOrganizationUsers/GetAllTeamMembershipList?userId=${id}`)
      .toPromise();
  }

  getAdminOrganizationGridData(id: any) {
    return this.http
      .get<any>(`${this.apiUrl}/Organization/GetAllOrganizationMembershipList?organizationId=${id}`)
      .toPromise();
  }

  getAdminOrganizationGridDataSync(id: any) {
    return this.http.get<any>(
      `${this.apiUrl}/Organization/GetAllOrganizationMembershipList?organizationId=${id}`
    );
  }

  deleteOrganizationDetailsGridData(id: any) {
    // For details grid inside admin organization page
    return this.http.delete<any>(
      `${this.apiUrl}/Organization/DeleteOrganizationMembership?id=${id}`
    );
  }

  deleteManageUserTeamMembershipData(id: any) {
    return this.http.delete<any>(
      `${this.apiUrl}/MyOrganizationUsers/DeleteTeamMembership?id=${id}`
    );
  }

  deleteManageUserUserMembershipData(id: any) {
    return this.http.delete<any>(
      `${this.apiUrl}/MyOrganizationUsers/DeleteOrganizationMembership?id=${id}`
    );
  }

  getTeamDetailsList(userId: any) {
    return this.http
      .get<any>(`${this.apiUrl}/MyOrganizationTeam/GetMyOrganizationTeamDetail?id=${userId}`)
      .toPromise();
  }

  getTeamDetailGridData(id: any) {
    return this.http
      .get<any>(`${this.apiUrl}/MyOrganizationTeam/GetAllTeamMembershipList?teamId=${id}`)
      .toPromise();
  }

  getAddOrganizationMembershipFormDetail(userId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/MyOrganizationUsers/GetAddOrganizationMembershipFormDetail?id=${userId}`
      )
      .toPromise();
  }
  addUpdateOrganizationMembership(data: any) {
    return this.http.post<any>(
      `${this.apiUrl}/MyOrganizationUsers/AddUpdateOrganizationMembership`,
      data
    );
  }
  addUpdateAdminOrganizationMembership(data: any) {
    return this.http.post<any>(`${this.apiUrl}/Organization/AddUpdateOrganizationMembership`, data);
  }

  getAddUsersTeamMembershipFormDetail(id: any, userId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/MyOrganizationUsers/GetTeamMembershipData?id=${id}&userId=${userId}`
      )
      .toPromise();
  }

  addUpdateManageUsersTeamMembership(data: any) {
    return this.http.post<any>(`${this.apiUrl}/MyOrganizationUsers/AddUpdateTeamMembership`, data);
  }

  getAddEditTeamMembershipDetail(id: any, teamId: any, organizationId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/MyOrganizationTeam/GetTeamMembershipData?id=${id}&teamId=${teamId}&organizationId=${organizationId}`
      )
      .toPromise();
  }

  getAddEditAdminOrganizationMembershipDetail(id: any, organizationId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/Organization/GetAddOrganizationMembershipFormDetail?id=${id}&organizationId=${organizationId}`
      )
      .toPromise();
  }

  addUpdateManageTeamsTeamMembership(data: any) {
    return this.http.post<any>(`${this.apiUrl}/MyOrganizationTeam/AddUpdateTeamMembership`, data);
  }

  deleteTeamsTeamMembership(id: any) {
    return this.http.delete<any>(`${this.apiUrl}/MyOrganizationTeam/DeleteTeamMembership?id=${id}`);
  }

  changePasswordOnNextLogin(userId: any, flag: any) {
    return this.http.post<any>(
      `${this.apiUrl}/MyOrganizationUsers/UpdateFlag?userId=${userId}&flag=${flag}`,
      {}
    );
  }

  getPaymentTransactionList() {
    return this.http.get<any>(`${this.apiUrl}/Transactions/GetAllTransactionList`);
  }

  getInvoiceById(transactionId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/Transactions/GetInvoiceByTransactionId?transactionId=${transactionId}`
    );
  }

  getInvoiceByIdWithPromise(transactionId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/Transactions/GetInvoiceByTransactionId?transactionId=${transactionId}`
      )
      .toPromise();
  }

  invoiceDownloadData(Invoiceid: any) {
    return this.http.get<any>(
      `${this.apiUrl}/Transactions/GetInvoiceAttachmentDetail?Invoiceid=${Invoiceid}`
    );
  }

  //Admin Manage user -> Org membership
  getAddAdminUsersOrgMembershipFormDetail(id: any, userId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/AdminMyOrganizationUser/GetAddOrganizationMembershipFormDetailforAdmin?id=${id}&userId=${userId}`
      )
      .toPromise();
  }

  getOrganizationWeightingList() {
    return this.http.post<any>(`${this.apiUrl}/OrganizationWeighting/GetOrganizationWeighting`, {});
  }

  getAllOrganizationWeighting() {
    return this.http
      .get<any>(`${this.apiUrl}/OrganizationWeighting/GetAllOrganizationWeighting`)
      .toPromise();
  }
  getAllOrganizationWeightingSecond() {
    return this.http
      .get<any>(`${this.apiUrl}/MyOrganizationPreferences/GetOrganizationPreferenceSettings`)
      .toPromise();
  }

  getRecycledContentForPreferences() {
    return this.http.get<any>(`${this.apiUrl}/Organization/GetRecycledContentValue`);
  }

  updateRecycledContentForPreferences(id: any) {
    return this.http.post<any>(
      `${this.apiUrl}/Organization/AddUpdateRecycledContentValue?value=${id}`,
      {}
    );
  }

  editCustomWeightings(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/OrganizationWeighting/AddEditCustomOrganizationWeighting`,
      payload
    );
  }

  uploadSKUData(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/SKUData/AddImportFile`, payload);
  }

  getProjectReportSettingList() {
    return this.http.get<any>(
      `${this.apiUrl}/OrganizationReportSetting/GetAllProjectReportSettingList`
    );
  }

  addEditProjectReportSetting(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/OrganizationReportSetting/AddUpdateProjectReportSetting`,
      payload
    );
  }

  deleteProjectSettingReportData(id: any) {
    return this.http.delete<any>(
      `${this.apiUrl}/OrganizationReportSetting/DeleteProjectReportSetting?id=${id}`
    );
  }

  getOrganizationCertificationData() {
    return this.http.get<any>(
      `${this.apiUrl}/MyOrganizationPreferences/GetOrganizationCertification`
    );
  }

  updateOrgCertificationName(data: any) {
    return this.http.post<any>(
      `${this.apiUrl}/MyOrganizationPreferences/UpdateOrganizationCertification`,
      data
    );
  }

  updateOrgCertificationImg(data: any) {
    // For certificate image
    return this.http.post<any>(
      `${this.apiUrl}/MyOrganizationPreferences/UpdateOrganizationCertificationImage`,
      data
    );
  }

  deleteSupplierName(id: any) {
    return this.http.delete<any>(
      `${this.apiUrl}/MyOrganizationPreferences/DeleteSupplier?id=${id}`
    );
  }

  uploadOrgImage(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/MyOrganizationPreferences/SaveOrganizationImage`,
      payload
    );
  }

  updateOrgImageConsent(logoConsent: boolean) {
    return this.http.get<any>(
      `${this.apiUrl}/MyOrganizationPreferences/SaveOrganizationLogoConsent?LogoConsent=${logoConsent}`
    );
  }

  setChartOpacity(opacity: number) {
    return this.http.get<any>(
      `${this.apiUrl}/MyOrganizationPreferences/SaveOrganizationOpacity?Opacity=${opacity}`
    );
  }

  uploadTermsAndConditionsFile(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/MyOrganizationPreferences/SaveOrganizationTermsDocument`,
      payload
    );
  }

  updateUploadTermsAndConditionsFile(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/MyOrganizationPreferences/SaveOrganizationTermsDocumentbyOrganizationId`,
      payload
    );
  }

  getPreferencesAllRoleList() {
    return this.http.get<any>(`${this.apiUrl}/MyOrganizationPreferences/GetAllRoleList`);
  }

  getPreferencesRolesDetails(id: any) {
    return this.http.get<any>(`${this.apiUrl}/MyOrganizationPreferences/GetRoleDetail?id=${id}`);
  }

  updateRoleAccess(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/MyOrganizationPreferences/UpdateRoleModule`,
      payload
    );
  }

  addRole(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/MyOrganizationPreferences/AddRole`, payload);
  }

  deleteRole(id: any) {
    return this.http.delete<any>(
      `${this.apiUrl}/MyOrganizationPreferences/DeleteRole?roleId=${id}`
    );
  }

  getMappingMasterData() {
    return this.http.get<any>(`${this.apiUrl}/ImportExcel/GetMappingMasterData`);
  }

  saveOrganizationMapData(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/ImportExcel/ImportMappingData`, payload);
  }

  saveOrganizationMapPreferenceData(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/MyOrganizationPreferences/UpdateOrganizationMapping`,
      payload
    );
  }

  deleteOrganizationMapping(id: any) {
    return this.http.delete<any>(
      `${this.apiUrl}/MyOrganizationPreferences/DeleteOrganizationMapping?id=${id}`
    );
  }

  updateOrganizationLicenseLevel(organizationId: any, licenseLevel: any) {
    return this.http.get<any>(
      `${this.apiUrl}/AdminMyOrganizationUser/UpdateOrganizationLicenseLevel?organizationId=${organizationId}&licenseLevel=${licenseLevel}`
    );
  }

  resetOrganizationLicenseLevel(organizationId: number) {
    return this.http.get<any>(
      `${this.apiUrl}/AdminMyOrganizationUser/ResetOrganizationLicenseLevel?organizationId=${organizationId}`
    );
  }

  importUsers(formData: any) {
    return this.http.post<any>(`${this.apiUrl}/MyOrganizationUsers/SaveUsers`, formData);
  }

  checkImportStatus() {
    return this.http.get<any>(`${this.apiUrl}/MyOrganizationUsers/CheckImportStatus`);
  }

  getAllRoleList() {
    return this.http.get<any>(`${this.apiUrl}/MyOrganizationUsers/GetAllRoleList`);
  }

  addUserViaLink(manageUserData: any) {
    return this.http.post<any>(`${this.apiUrl}/MyOrganizationUsers/AddUserViaLink`, manageUserData);
  }

  updateAcknowledgeImportError(userImportBatchId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/MyOrganizationUsers/UpdateAcknowledgeImportError?userImportBatchId=${userImportBatchId}`
    );
  }

  activateUserPreferences(uid: any) {
    return this.http.get<any>(`${this.apiUrl}/User/ActivateUserByUID?uid=${uid}`);
  }

  resetCustomOrganizationWeighting(indicatorId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/OrganizationWeighting/ResetCustomWeighting?indicatorId=${indicatorId}`
    );
  }

  resetLitterImpact() {
    return this.http.get<any>(`${this.apiUrl}/MyOrganizationPreferences/ResetLitterImpact`);
  }
}
